import React from "react";
import { TextField } from "@mui/material";
import AutocompleteComponent from "./AutocompleteComponent";
import RowContainer from "./RowContainer";
import { translateStatusString } from "../../utils/helpers/translateStatusString"; // Import the function
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/features/language/languageSlice";
import { translateFilterKeys } from "../../utils/helpers/translateFilterKeys";

const MultipleFilterComponent = ({
  filters,
  filterOptions,
  handleFilterChange,
}) => {
  const currentLanguage = useSelector(selectLanguage);
  const getOptionLabel = (option, filterKey) => {
    if (option === null || option === undefined) return "";

    if (filterKey === "project_status" || filterKey === "ticket_status") {
      return translateStatusString(option, currentLanguage);
    }
    if (filterKey === "category") {
      return translateFilterKeys(option.name, currentLanguage);
    }
    if (typeof option === "string") {
      if (Date.parse(option))
        return new Date(option).toLocaleString(
          currentLanguage === "IT" ? "it-IT" : "en-US",
          {
            year: "numeric",
            month: "numeric",
            day: "numeric",
          }
        );
      return option;
    }
    return option.name || "";
  };

  const getValue = (filterKey, value) => {
    if (!value) return null;
    if (Array.isArray(filterOptions[filterKey])) {
      const option = filterOptions[filterKey].find(
        (opt) => opt.name === value || opt.id === value || opt === value
      );
      return option || value;
    }
    return value;
  };

  return (
    <RowContainer
      start
      align="center"
      minGap
      style={{ flexWrap: "wrap", height: "50%", gap: "30px" }}
    >
      {Object.keys(filters).map((filterKey) => (
        <AutocompleteComponent
          key={filterKey}
          width="150px"
          value={getValue(filterKey, filters[filterKey])}
          onChange={(e, newValue) => {
            const valueToSend = newValue ? newValue.id || newValue : null;
            handleFilterChange(filterKey, valueToSend);
          }}
          options={filterOptions[filterKey] || []}
          getOptionLabel={(option) => getOptionLabel(option, filterKey)}
          isOptionEqualToValue={(option, value) =>
            option.id === value || option.name === value || option === value
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="filled"
              label={translateFilterKeys(filterKey, currentLanguage)}
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
      ))}
    </RowContainer>
  );
};

export default MultipleFilterComponent;
